 
import CreateHttpService from "../../helpers/HttpService";
import { buildDynamicURL } from "../../shared/baseUrl";
   const HttpService = CreateHttpService();
 
// applicant Dashboard Data
const applicantDashboardData = async () => {

  const HttpService = CreateHttpService();
  const { data }: any = await HttpService.get( '/api/v1/dashboard')  
 
  return data;
};

const getallApplicant = async (input) => {
  const { applicationStatus ,interviewStatus} = input; 
	const base = `/api/v1/application`;
	const url = buildDynamicURL(  base,  applicationStatus ,interviewStatus);
	const { data }: any = await HttpService.get(url)
	return data
}

// Get all applicant by ID
const getallapplicantbyID = async (id: any) => {
  
  const HttpService = CreateHttpService(); 
  const { data }: any = await HttpService.get(`/api/v1/application/${id}`)  
  return data;
};

// Applicant Post
const applicantPost = async (inputs: any) => { 
  const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/application`,inputs)  
  return data;
};

// Assign New Screening
const assignNewScreening = async (inputs: any) => { 
    const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/application/screening`,inputs)  
  return data;
};

const dropoutToScreening = async (inputs: any) => { 
    const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/application/dropout-screening`,inputs)  
  return data;
};

//   New Evalvation
const assignNewEvalvation = async (inputs: any) => { 
  const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/application/evaluating`,inputs) 
  return data;
};

// Get Application Assigned
const applicationassigned = async (id: any) => {
  const HttpService = CreateHttpService(); 
  const { data }: any = await HttpService.get( `/api/v1/application/application-assigned/${id}`)  
  return data;
};

// Send Email
const sendEmail = async (inputs: any) => { 
  const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/email/send-email`,inputs) 
  return data;
};

// Share  Application
const shareApplication = async (inputs: any) => {
  const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/application/share-application`,inputs) 
  return data;
};

// Schedule Applicant
const scheduleApplicant = async (input: any) => {
  const { id, inputs } = input;
  const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/application/schedule/${id}`,inputs) 
  return data;
};
// Update Applicant Screening Status 
const UpdateScreeningStatus = async (inputs: any) => {
  const { id, status, comment } = inputs;
   const HttpService = CreateHttpService(); 
  const { data } = await HttpService.put( `/api/v1/application/screening/${id}`, {
      status: status,
      comment: comment,
    },) 
  return data;
};


const UpdateEvaluatingStatus = async (inputs: any) => {
  const { id, status, comment } = inputs; 
     	 const HttpService = CreateHttpService(); 
    const { data } = await HttpService.put( `/api/v1/application/evaluating/${id}`, {
      status: status,
      comment: comment,
    })  
  return data;
};

// Update Offer
const UpdateOffer = async (input: any) => {
  const { inputs, id } = input 
  
     	 const HttpService = CreateHttpService(); 
    const { data } = await HttpService.put( `/api/v1/application/send-offer/${id}`, inputs)  
  return data;
};
// update Tranning
const updateTranning = async (input: any) => {
  const { inputs, id } = input 
     	 const HttpService = CreateHttpService(); 
    const { data } = await HttpService.put( `/api/v1/application/training/${id}`, inputs)  
  return data;
};


// Update Interview Status
const updateInterviewStatus = async (inputs: any) => {
  
  const { id, status,interviewScore, comment } = inputs; 
 
    	 const HttpService = CreateHttpService(); 
  const { data } = await HttpService.put( `/api/v1/application/application-interview/${id}`,{
    "status": status,
    "interviewScore": interviewScore,
    "comment": comment
  })  
  return data
}
// Application Interview
const applicationInterview = async (inputs: any) => {  
  	 const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/application/application-interview`,inputs)  
  return data
}

// Send Offer
const sendOffer = async (inputs: any) => { 

	 const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/application/send-offer`,inputs)  
  return data
}



// Update Application Interview Status
const updateApplicationInterviewStatus = async (inputs: any) => { 
   const { id, status, body } = inputs; 
  	 const HttpService = CreateHttpService(); 
  const { data } = await HttpService.put( `/api/v1/application/${id}`,{ 
    "status": status, 
    "body": body
  })  
  return data
}
// Send For Hire
const sendForHire = async (inputs: any) => {  
  	 const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/application/hire`,inputs)  
  return data
}
// Send For Tranning
const sendForTranning = async (inputs: any) => {  
  	 const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post( `/api/v1/application/training`,inputs)  
  return data
}


 // Edit Application
const EditApplication = async (inputs:any) => { 
  const { formattedInput, id } = inputs;  
  const HttpService = CreateHttpService(); 
  const { data } = await HttpService.put(`/api/v1/application/${id}`, formattedInput)   
  return  data
}
 
 // Edit Application
const ResignApplicant= async (inputs:any) => {  
  const HttpService = CreateHttpService(); 
  const { data } = await HttpService.post(`/api/v1/application/application-resigned`, inputs)   
  return  data
}
const applicantService = {
  getallApplicant,
  getallapplicantbyID,
  applicantPost,
  assignNewScreening,
  assignNewEvalvation,
  applicationassigned,
  sendEmail,
  shareApplication,
  scheduleApplicant,
  UpdateScreeningStatus,
  UpdateEvaluatingStatus,
  updateInterviewStatus,
  applicationInterview,
  sendOffer,
  updateApplicationInterviewStatus,
  applicantDashboardData,
  dropoutToScreening,
  UpdateOffer,
  sendForHire,
  EditApplication,
  sendForTranning,
  updateTranning,
  ResignApplicant
};

export default applicantService;
